/// <reference types="jquery"/>
/// <reference types="datatables.net"/>


class DataTableNavigationEvent {
    tableId: string;
    eventName: string;
    url: string;
}

class DataTableHelper {
    static initDataTables() {
        $('.datatable:not(.datatable-init)').each((index: number, element: Element) => {
            DataTableHelper.initDataTable(element);
        });
    }

    static getSelectedValues(element: Element) {
        const $dataTable = $(element);
        return DataTableExtension.selectedRows[$dataTable.attr('id')]; 
    }
    
    static setSelectedValues(element: Element, ids: any) {
        const $dataTable = $(element);
        return DataTableExtension.selectedRows[$dataTable.attr('id')] = ids; 
    }

    static initDataTable(element: Element) {        
        var $dataTable = $(element);
        var dataTableSettings = {
            responsive: true,
            serverSide: true,
            stateSave: true,
            orderCellsTop: true,
            fixedHeader: true,
            rowCallback: (row) => {
                const index = DataTableExtension.selectedRows[element.id].indexOf(row.id);
                if (index === -1)
                    return;
                
                $(row).find('input[type="checkbox"]').prop('checked', true);  
            },
            stateSaveCallback: (settings, data) => {
                const key = DataTableExtension.getStorageKey(settings.nTable);
                window.localStorage.setItem(key, JSON.stringify(data));
            },
            stateLoadCallback: (settings, callback) => {
                const key = DataTableExtension.getStorageKey(settings.nTable);
                const data = window.localStorage.getItem(key);
                const json = data ? JSON.parse(data) : {};

                callback(json);
            },
            dom: "<'row'<'col-md-2 col-xs-2'l><'extra col-md-5 col-xs-5'><'pull-right col-md-3 col-md-3'Bf>>" +
                "<'row'<'col-md-6 col-xs-6'><'col-md-6 col-xs-6'>>" +
                "<'row'<'col-md-12 col-xs-12 't>>" +
                "<'row'<'col-md-6 col-xs-6'i><'col-md-6 col-xs-6'p>>",
            ajax: {
                url: $dataTable.data('url'),
                type: 'POST',
                data: $dataTable.data('url-data')
            },
            processing: true,
            columns: [],
            columnDefs: [],
            headerCallback: function (thead, data, start, end, display) {
                const attributes = this.fnSettings().oInit.columnAttributes;

                for (let i = 0; i < attributes.length; i++) {
                    const attribute = attributes[i];
                    const $th = $(thead).find('th').eq(attribute.column);

                    for (let y = 0; y < attribute.attributes.length; y++) {
                        const attributeValues = attribute.attributes[y];
                        $th.attr(attributeValues.name, attributeValues.value);
                    }
                }
            },
            columnAttributes: []
        };

        const languageCode = document.documentElement.lang;
        if (languageCode !== 'en') {
            dataTableSettings['language'] = {
                url: `/locales/datatable/${languageCode}.json`
            };
        }

        if (!$dataTable.data('load-metadata')) {
            dataTableSettings["order"] = $dataTable.data('order');

            //data is serverside al aangeleverd, haal de informatie op uit document tree
            const $tds = $dataTable.find('thead>tr>th');

            //haal de id's op uit tree
            for (let i = 0; i < $tds.length; i++) {
                const $td = $tds.eq(i);
                var columnSettings = <any>{
                    name: $td.text(),
                    data: $td.data('id')
                };
                if ($td.data('sort-disabled')) {
                    columnSettings.orderable = false;
                }
                if ($td.data('search-disabled')) {
                    columnSettings.searchable = false;
                }
                var width = $td.data('width');
                if (width) {
                    columnSettings.width = width;
                }
                dataTableSettings.columns.push(columnSettings);
            }

            //init datatable
            DataTableExtension.init($dataTable, dataTableSettings);
            return;
        }

        //voer interactie uit en vraag metadata op
        console.error('This function is obsolete, the server should call the meta data directly! Make sure your action method is working!');
        
        $.ajax({
            url: dataTableSettings.ajax.url,
            data: { metaData: true },
            dataType: 'json',
            success: data => {
                //zet kolommen
                dataTableSettings.columns = data.columns;

                //zet sorteringen
                if (data.order.length > 0) {
                    dataTableSettings["order"] = [];
                    for (let s = 0; s < data.order.length; s++) {
                        const sort = data.order[s];
                        dataTableSettings["order"].push([sort.column, sort.direction]);
                    }
                }
                //voeg thead en tbody toe
                $dataTable.append($('<thead><tr></tr></thead><tbody></tbody>'));
                var $tr = $dataTable.find('tr');
                for (let c = 0; c < data.columns.length; c++) {
                    //voeg headers toe
                    const $th = $('<th></th>');
                    $tr.append($th.text(data.columns[c].name));
                }

                dataTableSettings.columnAttributes = data.columnAttributes;

                //init datatable
                DataTableExtension.init($dataTable, dataTableSettings);

            },
            error() {
                //fout, geef foutmelding (indien gekoppeld)
                const props = new ErrorProperties();
                props.message =
                    `We are sorry, something went wrong while trying to receive some data.. (Source: ${
                    $dataTable.attr('id')})`;
                DataTableExtension.error(props);
            }
        });
    }
}

class DataTableExtension {
    static errors: Function[];
    static idPropertyName: string;

    static datatables: any = {};
    static selectedRows: any = {};

    static registerErrorCallBack(callback: Function) {
        DataTableExtension.errors.push(callback);
    }

    static setIdPropertyName(name: string) {
        DataTableExtension.idPropertyName = name;
    }

    static error(properties: ErrorProperties) {
        for (let x = 0; x < DataTableExtension.errors.length; x++) {
            DataTableExtension.errors[x].apply(properties);
        }
    }

    static getStorageKey(table) {
        const url = table.dataset.url;
        const urlData = table.dataset.urlData;

        return `${url}+${urlData}`;
    }

    //init datatable
    static init($dataTable: JQuery, settings: any) {
        const key = DataTableExtension.getStorageKey($dataTable[0]);
        const data = JSON.parse(window.localStorage.getItem(key));

        const $rowClone = $dataTable.find('thead tr').clone(true);
        $rowClone.appendTo($dataTable.find('thead'));

        let searchTimeout = null;
        var fnSearch = (column, value)=>{
            column
                .search( value )
                .draw();
        };

        $dataTable.find('thead tr:eq(1) th').each( function (i, value) {
            const $this = $(value);
            const title = $this.text();
            if ($this.data('search-disabled'))
            {
                $this.empty();
                return;
            }
            const $input = $('<input type="text" class="form-control" style="width: 100%;" placeholder="' + title + '" />');
            if (data != null) {
                var dataColumn = data.columns[i];
                if (dataColumn != null) {
                    $input.val(dataColumn.search.search);
                }
            }
            $this.empty();
            $this.append($input);
    
            $( 'input', this ).on( 'keyup change', function () {
                if ( table.column(i).search() !== this.value ) {
                    if (searchTimeout != null)
                    {
                        clearTimeout(searchTimeout);
                    }
                    searchTimeout = setTimeout(()=> fnSearch(table.column(i), this.value), 400);
                }
            } );
        } );

        const table = $dataTable.DataTable(settings);

        DataTableExtension.datatables[$dataTable.attr('id')] = table;
        DataTableExtension.selectedRows[$dataTable.attr('id')] = [];
        $dataTable.addClass('datatable-init');
        //select all checkbox.
        $dataTable.on('change', 'thead tr input.select-all', (event) => {
            const $this = $(event.currentTarget);
            
            // Indien true, deselecteren wij alleen de huidige pagina, anders wordt alles gedeselecteerd
            const deselectCurrentPage = $dataTable.data('deselectCurrentPage'); 
            if (!$this.is(':checked') && !deselectCurrentPage){
                console.log('deselect everything')
                const datatableId = $dataTable.attr('id');
                DataTableExtension.selectedRows[datatableId] = [];
            }
            
            $dataTable.find('tbody tr div.checkbox.c-checkbox input[type="checkbox"]:not(:disabled)').prop('checked', $this.prop('checked')).trigger('change');
        });
        $dataTable.on('change', 'tbody tr div.checkbox.c-checkbox input[type="checkbox"]:not(:disabled)', ev => {
           const datatableId = $dataTable.attr('id');
           const selectedRows = DataTableExtension.selectedRows[datatableId];
           const $this = $(ev.currentTarget);
           const $row = $this.closest('tr');
           const rowId = $row.attr('id');
           
           if ($this.is(':checked'))
           {
               if (selectedRows.indexOf(rowId) > -1){
                   return;
               }
               selectedRows.push(rowId);
               $dataTable.trigger('onCheckboxChanged', [rowId, true]);
               return;
           }
           $dataTable.find('input.select-all').prop('checked', false);
           const index = selectedRows.indexOf(rowId); 
           if (index === -1){
               return;
           }
           selectedRows.splice(index, 1); 
           $dataTable.trigger('onCheckboxChanged', [rowId, false]);
        } );
        var clickFunction = $dataTable.data('event-click-function');
        if (clickFunction) {
            $dataTable.on('click', 'tbody tr', (event) => {
                var data =
                {
                    id: $(event.currentTarget).attr('id'),
                    datatableId: $dataTable.attr("id")
                };

                var value = eval(clickFunction + "(" + JSON.stringify(data) + ")");
                if (typeof value === "function")
                    value(event);
            });
            return;
        }

        //koppel click event navigatie
        const clickUrl = $dataTable.data('event-click-navigation');
        
        if (clickUrl) {
            $dataTable.on('click', 'tbody tr', (event) => {
                let navigation = clickUrl;
                if (!$(event.target).is('tr') && !$(event.target).is('td')) {
                    event.stopPropagation();
                    return;
                }
                if (navigation.indexOf('?') === -1)
                    navigation += '?';
                else
                    navigation += '&';

                const idValue = $(event.currentTarget).attr('id');
                if (!idValue) {
                    event.stopPropagation();
                    return;
                }
                const idName = DataTableExtension.idPropertyName || "id";
                
                navigation += `${idName}=${encodeURIComponent(idValue)}`;

                //should we open in a new window?
                const newWindow = $dataTable.data('new-window');
                if (newWindow) {
                    window.open(navigation);
                }
                else {
                    window.location.href = navigation;
                }
            });
        }
    }
}

class ErrorProperties {
    message: string
}

(() => {
    DataTableHelper.initDataTables();
})();
